import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../../../CSS/ViewUser.css";
import {
  fetchUserById,
  updateUserById,
  deleteUserById,
  resetUserPassword,
} from "../../../Services/usersService";
import {
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  MenuItem,
  Grid,
  Box,
  Chip,
  OutlinedInput,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import UserInstance from "../../../Services/UserInstance";
import OrganizationService from "../../../Services/OrganizationService";
import ProjectService from "../../../Services/ProjectService";
import UsertoModuleService from "../../../Services/UsertoModuleService";
import UsertoProjectService from "../../../Services/UsertoProjectService";
import ModuleService from "../../../Services/ModuleService";

export default function ViewUser() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("details");
  const [isEditing, setIsEditing] = useState(false);
  const [editUser, setEditUser] = useState({});
  const [error, setError] = useState(null);
  // reset password dialog state
  const [isResetOpen, setIsResetOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [userOrganizations, setUserOrganization] = useState([]);
  const [orgProjectsMap, setOrgProjectsMap] = useState({});
  const [expandedOrgId, setExpandedOrgId] = useState(null);
  const [allOrganizations, setAllOrganizations] = useState([]);
  const [projectModulesMap, setProjectModulesMap] = useState({});
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [userToModuleId, setUserToModuleId] = useState(null);


  const REALM = "navaantrix";

  const userProjectIds =
    (user?.data?.attributes?.swaggerProjectIds || user?.data?.attributes?.swaggerProjectIdss)?.map(Number) || [];

  //   const selectedOrgId =
  // editUser.attributes?.swaggerOrganizationIds?.[0];

  const hasOrganization =
    editUser.attributes?.swaggerOrganizationIds?.length > 0;

  const selectedOrgId = hasOrganization
    ? Number(editUser.attributes.swaggerOrganizationIds[0])
    : null;

  const availableProjects = selectedOrgId
    ? orgProjectsMap[selectedOrgId] || []
    : [];

  useEffect(() => {
    console.log("Reset dialog open state:", isResetOpen);
  }, [isResetOpen]);

  useEffect(() => {
    loadUser();
  }, [userId]);

  useEffect(() => {
    OrganizationService.getAllOrganizations()
      .then((res) => setAllOrganizations(res.data))
      .catch((err) => console.error("Failed to load orgs", err));
  }, []);

  // const [userToModuleId, setUserToModuleId] = useState(null);

  useEffect(() => {
    if (!userId) return;

    UsertoModuleService.getUserToModuleIdByUserId(userId)
      .then((res) => {
        const mappings = res.data || [];

        if (!mappings.length) {
          setSelectedModuleIds([]);
          setUserToModuleId(null); // important
          return;
        }

        const mapping = mappings[0]; // ONE row per user
        setUserToModuleId(mapping.userToModuleId);

        const modules = mapping.modules || [];
        const moduleIds = modules.map((m) => Number(m.id));

        setSelectedModuleIds(moduleIds);
      })
      .catch((err) =>
        console.error("Failed to load user modules", err)
      );
  }, [userId]);



  const loadUser = async () => {
    try {
      const res = await fetchUserById(userId);

      const userData = res?.data?.data ?? res?.data ?? res;

      console.log("Fetched user data:", userData);

      if (!userData || !userData.id) {
        throw new Error("Invalid user data");
      }

      setUser({ data: userData });
      setEditUser({
        ...userData,
        attributes: {
          swaggerOrganizationIds:
            userData.attributes?.swaggerOrganizationIds || [],
          swaggerProjectIds: userData.attributes?.swaggerProjectIds || userData.attributes?.swaggerProjectIdss || [],
          swaggerProjectIdss: userData.attributes?.swaggerProjectIdss || userData.attributes?.swaggerProjectIds || [],
        },
      });

      if (res.status === 200) {
        const userRolesResponse = await UserInstance.get(
          `/api/users/realms/${REALM}/user/${userData.id}/role-mapping`,
        );
        // Change to use clientMappings instead of realmMappings
        const clientMappings = userRolesResponse?.data?.data?.clientMappings;
        const mappings = clientMappings
          ? Object.values(clientMappings).flatMap(
            (client) => client.mappings || [],
          )
          : [];
        setUserRoles(mappings);
      }

      const orgIds = userData.attributes?.swaggerOrganizationIds;
      const fetchOrganizationsWithRoles = async () => {
        if (!orgIds || orgIds.length === 0) return;

        try {
          const responses = await Promise.all(
            orgIds.map((orgId) =>
              OrganizationService.getOrganizationbyid(Number(orgId)),
            ),
          );

          const organizationsData = responses.map((res) => ({
            organizationId: res.data.organizationId,
            organizationName: res.data.organizationName,
            statusId: res.data.statusId,
          }));

          setUserOrganization(organizationsData);
        } catch (error) {
          console.error("Failed to fetch organization roles", error);
        }
      };

      fetchOrganizationsWithRoles();

      // console.log("FeatchOrganization:", userOrganizations);
    } catch (err) {
      console.error("Load user failed", err);
      setError("Failed to load user");
    }
  };

  const loadOrgProjects = async (organizationId) => {
    try {
      const res =
        await ProjectService.getProjectsByOrganization(organizationId);

      setOrgProjectsMap((prev) => ({
        ...prev,
        [organizationId]: res.data, // ALL org projects
      }));
    } catch (error) {
      console.error("Failed to load organization projects", error);
    }
  };

  const loadModulesByProject = async (projectId) => {
    try {
      const res = await ModuleService.getModuleByProjectId(projectId);

      setProjectModulesMap((prev) => ({
        ...prev,
        [projectId]: res.data,
      }));
    } catch (err) {
      console.error("Failed to load modules for project", err);
    }
  };

  // const loadOrgProjects = async (organizationId) => {
  //   try {
  //     if (!userProjectIds.length) {
  //       setOrgProjectsMap((prev) => ({
  //         ...prev,
  //         [organizationId]: [],
  //       }));
  //       return;
  //     }

  //     const projectResponses = await Promise.all(
  //       userProjectIds.map((projectId) =>
  //         ProjectService.getProjectById(organizationId, projectId)
  //           .then((res) => res.data)
  //           .catch(() => null),
  //       ),
  //     );

  //     const validProjects = projectResponses.filter(Boolean);

  //     setOrgProjectsMap((prev) => ({
  //       ...prev,
  //       [organizationId]: validProjects,
  //     }));
  //   } catch (error) {
  //     console.error("Failed to load projects", error);
  //   }
  // };

  const handleSave = async () => {
    setError(null);
    if (!editUser.attributes?.swaggerOrganizationIds?.length) {
      setError("Please assign an organization before saving");
      return;
    }
    try {
      const payload = {
        username: editUser.username,
        firstName: editUser.firstName,
        lastName: editUser.lastName,
        email: editUser.email,
        enabled: !!editUser.enabled,
        attributes: {
          swaggerOrganizationIds:
            editUser.attributes.swaggerOrganizationIds.map(String),
          swaggerProjectIds: editUser.attributes.swaggerProjectIds.map(String),
          swaggerProjectIdss: editUser.attributes.swaggerProjectIds.map(String),
        },
      };

      await updateUserById(userId, payload);

      const projectIds = editUser.attributes.swaggerProjectIds || [];

      if (projectIds.length > 0) {
        await UsertoProjectService.assignProjectToUser(
          userId,
          projectIds.map(Number),
          null
        );
      }
      //  Sync USER → MODULE
      const modulePayload = {
        userId: userId,
        moduleIds: selectedModuleIds.map(Number),
      };


      if (userToModuleId) {
        await UsertoModuleService.updateModule(
          userToModuleId,
          modulePayload
        );
      } else {
        const res = await UsertoModuleService.createUserToModule(modulePayload);

        //  update local state so next save becomes UPDATE
        setUserToModuleId(res.data?.userToModuleId || res.data?.id);
      }



      // Update local state
      setUser((prev) => ({
        ...prev,
        data: { ...(prev.data || {}), ...payload },
      }));
      setIsEditing(false);
    } catch (err) {
      console.error("Update failed", err);
      setError("Failed to update user");
    }
  };

  const handleDelete = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this user? This action cannot be undone.",
    );

    if (!confirmed) return;

    try {
      await deleteUserById(userId);
      alert("User deleted successfully");
      navigate("/users"); // go back to user list
    } catch (err) {
      console.error(err);
      alert("Failed to delete user");
    }
  };

  const handleCancel = () => {
    setEditUser(user && user.data ? { ...user.data } : { ...user }); // rollback
    setIsEditing(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusToggle = () => {
    setEditUser((prev) => ({
      ...prev,
      enabled: !prev.enabled,
    }));
  };

  const handleResetPassword = async () => {
    try {
      const uid = user?.data?.id;
      if (!uid) {
        console.error("No user id available for reset");
        alert("Unable to determine user id for reset");
        return;
      }

      const formData = new URLSearchParams();
      formData.append("realm", "navaantrix");
      formData.append("userId", uid);
      formData.append("newPassword", newPassword);
      formData.append("clientId", "swagger");

      const res = await UserInstance.post(
        "/api/users/resetUserPassword",
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      // const res = await resetUserPassword(formData);
      const msg = res?.data?.message || "Password reset successfully";
      alert(msg);
      setIsResetOpen(false);
      setNewPassword("");
      setShowPassword(false);
    } catch (error) {
      console.error("Reset password failed", error);
      if (error.response) {
        console.error("Response status", error.response.status);
        console.error("Response data", error.response.data);
        alert(
          error.response.data?.message ||
          `Failed to reset password (${error.response.status})`,
        );
      } else {
        alert(error.message || "Failed to reset password (network error)");
      }
    }
  };

  const handleUnassignRole = async (userRole) => {
    try {
      const payload = [{ id: userRole.id, name: userRole.name }];

      await UserInstance.delete(`/api/users/realms/${REALM}/users/${userId}`);

      setUserRoles((prev) => prev.filter((role) => role.id !== userRole.id));
      alert("Role unassigned");
    } catch (error) {
      console.error(error);
      alert("Failed to unassign role");
    }
  };

  if (!user) return <div className="loading">Loading...</div>;

  return (
    <div className="view-user-container">
      <div className="view-user-header">
        <h2>
          <span className="users-text">Users</span> / View User
        </h2>

        <div className="header-actions">
          {!isEditing && (
            <>
              <button className="btn back" onClick={() => navigate(-1)}>
                ← BACK
              </button>

              <button className="btn delete" onClick={handleDelete}>
                {" "}
                DELETE{" "}
              </button>

              <button
                className="btn edit"
                disabled={
                  !user?.data?.attributes?.swaggerOrganizationIds?.length
                }
                title="User has no organization assigned"
                onClick={() => {
                  setEditUser(
                    user && user.data ? { ...user.data } : { ...user },
                  );
                  setIsEditing(true);
                }}

              >
                EDIT
              </button>

              <button
                type="button"
                className="btn reset"
                onClick={() => {
                  console.log("Reset button clicked");
                  setIsResetOpen(true);
                }}
                aria-haspopup="dialog"
              >
                RESET PASSWORD
              </button>
            </>
          )}
        </div>

        {isEditing && (
          <>
            <button className="btn edit" onClick={handleSave}>
              SAVE
            </button>
            <button className="btn back" onClick={handleCancel}>
              CANCEL
            </button>
          </>
        )}
      </div>

      <div className="card">
        <div className="tabs">
          <div
            className={`tab ${activeTab === "details" ? "active" : ""}`}
            onClick={() => setActiveTab("details")}
          >
            DETAILS
          </div>
          <div
            className={`tab ${activeTab === "roles" ? "active" : ""}`}
            onClick={() => setActiveTab("roles")}
          >
            ROLES
          </div>
          <div
            className={`tab ${activeTab === "organizations" ? "active" : ""}`}
            onClick={() => setActiveTab("organizations")}
          >
            ORGANIZATIONS
          </div>
        </div>

        {activeTab === "details" && (
          <div className="form-grid">
            {error && (
              <div className="form-error">
                <Alert variant="filled" severity="error">
                  {error}
                </Alert>
              </div>
            )}

            <div className="form-group">
              <label>Username</label>
              <input
                name="username"
                value={
                  isEditing
                    ? editUser.username || ""
                    : user?.data?.username || ""
                }
                readOnly={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>First Name</label>
              <input
                name="firstName"
                value={
                  isEditing
                    ? editUser.firstName || ""
                    : user?.data?.firstName || ""
                }
                readOnly={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Last Name</label>
              <input
                name="lastName"
                value={
                  isEditing
                    ? editUser.lastName || ""
                    : user?.data?.lastName || ""
                }
                readOnly={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group email-group">
              <label>Email</label>
              <input
                name="email"
                value={
                  isEditing ? editUser.email || "" : user?.data?.email || ""
                }
                readOnly={!isEditing}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Organization</label>

              {!isEditing ? (
                <input
                  readOnly
                  value={
                    userOrganizations.length
                      ? userOrganizations
                        .map((o) => o.organizationName)
                        .join(", ")
                      : "—"
                  }
                />
              ) : (
                <TextField
                  select
                  fullWidth
                  value={editUser.attributes.swaggerOrganizationIds[0] || ""}
                  onChange={async (e) => {
                    const newOrgId = Number(e.target.value);

                    setEditUser((prev) => ({
                      ...prev,
                      attributes: {
                        ...prev.attributes,
                        swaggerOrganizationIds: [newOrgId],
                        swaggerProjectIds: [], //  reset projects
                      },
                    }));

                    // reload projects for selected org
                    await loadOrgProjects(newOrgId);
                  }}
                >
                  {(userOrganizations.length
                    ? userOrganizations
                    : allOrganizations
                  ).map((org) => (
                    <MenuItem
                      key={org.organizationId}
                      value={org.organizationId}
                    >
                      {org.organizationName}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </div>

            <div className="form-group full-width">
              <label>Projects</label>

              {!isEditing ? (
                <div className="chip-container">
                  {Object.values(orgProjectsMap)
                    .flat()
                    .filter(
                      (project) =>
                        user?.data?.attributes?.swaggerProjectIds?.includes(
                          String(project.id),
                        ) ||
                        user?.data?.attributes?.swaggerProjectIds?.includes(
                          project.id,
                        ) ||
                        user?.data?.attributes?.swaggerProjectIdss?.includes(
                          String(project.id),
                        ) ||
                        user?.data?.attributes?.swaggerProjectIdss?.includes(
                          project.id,
                        ),
                    ).length > 0 ? (
                    Object.values(orgProjectsMap)
                      .flat()
                      .filter(
                        (project) =>
                          user?.data?.attributes?.swaggerProjectIds?.includes(
                            String(project.id),
                          ) ||
                          user?.data?.attributes?.swaggerProjectIds?.includes(
                            project.id,
                          ) ||
                          user?.data?.attributes?.swaggerProjectIdss?.includes(
                            String(project.id),
                          ) ||
                          user?.data?.attributes?.swaggerProjectIdss?.includes(
                            project.id,
                          ),
                      )
                      .map((project) => (
                        <Chip
                          key={project.id}
                          label={project.name}
                          size="small"
                        />
                      ))
                  ) : (
                    "—"
                  )}
                </div>
              ) : (
                <TextField
                  select
                  fullWidth
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const proj = availableProjects.find(
                            (p) => p.id === value,
                          );
                          return (
                            <Chip
                              key={value}
                              label={proj?.name || value}
                              size="small"
                              onDelete={() => {
                                const newIds = editUser.attributes.swaggerProjectIds.filter(
                                  (id) => id !== value
                                );
                                // Update state
                                setEditUser((prev) => ({
                                  ...prev,
                                  attributes: {
                                    ...prev.attributes,
                                    swaggerProjectIds: newIds,
                                  },
                                }));
                                // Clear modules for this project
                                const modulesToKeep = selectedModuleIds.filter((mId) => {
                                  const mod = Object.values(projectModulesMap).flat().find(m => m.id === mId);
                                  return mod?.projectId !== value;
                                });
                                setSelectedModuleIds(modulesToKeep);
                              }}
                              onMouseDown={(e) => e.stopPropagation()}
                            />
                          );
                        })}
                      </Box>
                    ),
                  }}
                  value={editUser.attributes.swaggerProjectIds}
                  onChange={async (e) => {
                    const projectIds = e.target.value;

                    setEditUser((prev) => ({
                      ...prev,
                      attributes: {
                        ...prev.attributes,
                        swaggerProjectIds: projectIds,
                      },
                    }));

                    // Load modules for newly selected projects
                    for (const projectId of projectIds) {
                      if (!projectModulesMap[projectId]) {
                        await loadModulesByProject(projectId);
                      }
                    }
                  }}
                  disabled={!selectedOrgId}
                  helperText={!selectedOrgId ? "Select organization first" : ""}
                >
                  {availableProjects
                    .filter(
                      (p) =>
                        !editUser.attributes.swaggerProjectIds.includes(p.id),
                    )
                    .map((project) => (
                      <MenuItem key={project.id} value={project.id}>
                        {project.name}
                      </MenuItem>
                    ))}
                </TextField>
              )}
            </div>
            {/* ================= MODULES ================= */}
            <div className="form-group full-width">
              <label>Modules</label>

              {!isEditing ? (
                <div className="chip-container">
                  {selectedModuleIds.length > 0 ? (
                    Object.values(projectModulesMap)
                      .flat()
                      .filter((m) => selectedModuleIds.includes(m.id))
                      .map((m) => (
                        <Chip key={m.id} label={m.name} size="small" />
                      ))
                  ) : (
                    "—"
                  )}
                </div>
              ) : (
                <TextField
                  select
                  fullWidth
                  SelectProps={{
                    multiple: true,
                    renderValue: (selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((val) => {
                          const allModules = Object.values(
                            projectModulesMap,
                          ).flat();
                          const mod = allModules.find((m) => m.id === val);
                          return (
                            <Chip
                              key={val}
                              label={mod?.name || val}
                              size="small"
                              onDelete={() => {
                                const newIds = selectedModuleIds.filter(
                                  (id) => id !== val
                                );
                                setSelectedModuleIds(newIds);
                              }}
                              onMouseDown={(e) => e.stopPropagation()}
                            />
                          );
                        })}
                      </Box>
                    ),
                  }}
                  value={selectedModuleIds}
                  onChange={(e) => setSelectedModuleIds(e.target.value)}
                  disabled={!editUser.attributes?.swaggerProjectIds?.length}
                  helperText={
                    !editUser.attributes?.swaggerProjectIds?.length
                      ? "Select project first"
                      : ""
                  }
                >
                  {Object.values(projectModulesMap)
                    .flat()
                    .filter((m) => !selectedModuleIds.includes(m.id))
                    .map((module) => (
                      <MenuItem key={module.id} value={module.id}>
                        {module.name}
                      </MenuItem>
                    ))}
                </TextField>
              )}
            </div>
            {/* ================= END MODULES ================= */}

            <div className="status-toggle">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={
                    !!(isEditing ? editUser.enabled : user?.data?.enabled)
                  }
                  onChange={handleStatusToggle}
                  disabled={!isEditing}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        )}

        {activeTab === "roles" && (
          <div className="roles-container">
            {userRoles.length ? (
              userRoles.map((role) => (
                <div key={role.id} className="role-card">
                  <span className="role-name">{role.name}</span>

                  {isEditing && (
                    <button
                      className="unassign-btn"
                      onClick={() => handleUnassignRole(role)}
                    >
                      UNASSIGN
                    </button>
                  )}
                </div>
              ))
            ) : (
              <p className="no-roles">No roles assigned</p>
            )}
          </div>
        )}

        {activeTab === "organizations" && (
          <div className="org-access-list">
            {userOrganizations.length ? (
              userOrganizations.map((org) => {
                const isExpanded = expandedOrgId === org.organizationId;

                return (
                  <div key={org.organizationId} className="org-block">
                    <div
                      className="org-header"
                      onClick={() => {
                        setExpandedOrgId(
                          isExpanded ? null : org.organizationId,
                        );

                        if (
                          !isExpanded &&
                          !orgProjectsMap[org.organizationId]
                        ) {
                          loadOrgProjects(org.organizationId);
                        }
                      }}
                    >
                      <span className="org-name">{org.organizationName}</span>
                      <span className="org-arrow">
                        {isExpanded ? "▼" : "▶"}
                      </span>
                    </div>

                    {isExpanded && (
                      <div className="project-list">
                        {orgProjectsMap[org.organizationId]?.filter(
                          (project) =>
                            editUser.attributes?.swaggerProjectIds?.includes(
                              String(project.id),
                            ) ||
                            editUser.attributes?.swaggerProjectIds?.includes(
                              project.id,
                            ),
                        )?.length ? (
                          orgProjectsMap[org.organizationId]
                            .filter(
                              (project) =>
                                editUser.attributes?.swaggerProjectIds?.includes(
                                  String(project.id),
                                ) ||
                                editUser.attributes?.swaggerProjectIds?.includes(
                                  project.id,
                                ),
                            )
                            .map((project) => (
                              <div key={project.id} className="project-block">
                                <div className="project-header">
                                  <span className="project-name">
                                    {project.name}
                                  </span>
                                  <span className="project-arrow">▶</span>
                                </div>
                              </div>
                            ))
                        ) : (
                          <div className="no-projects">
                            No projects assigned
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <p className="no-roles">No organizations assigned</p>
            )}
          </div>
        )}

        <Dialog
          open={isResetOpen}
          onClose={() => setIsResetOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          {/* Reset Password Dialog */}
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontWeight: 600,
            }}
          >
            <LockIcon color="primary" />
            Reset Password
          </DialogTitle>
          <DialogContent sx={{ pb: 1 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Enter a new password for the user. Make sure it's strong and
              secure.
            </Typography>
            <TextField
              label="New Password"
              type={showPassword ? "text" : "password"}
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={() => {
                setIsResetOpen(false);
                setNewPassword("");
                setShowPassword(false);
              }}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleResetPassword}
              variant="contained"
              disabled={!newPassword.trim()}
            >
              Reset Password
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}
